import React, { useContext, useState, useEffect } from 'react';
import propTypes from 'prop-types';
import useRequest from '../Hooks/useRequest';
import { useAdvertisers } from './AdvertisersContext';

const CampaignsContext = React.createContext();

export function useCampaigns() {
    return useContext(CampaignsContext);
}

export function CampaignsProvider({ children }) {
    const [campaigns, setCampaigns] = useState({
        selectedCampaign: {},
        allCampaignsList: [],
        linkedAdvertiserCampaigns: [],
    });

    const { advertisers, currentAdvertiser } = useAdvertisers();
    const selectedAdvertiserId = currentAdvertiser?._id;

    const { data: linkedAdvertiserCampaigns, mutate: mutateLinkedAdvertiserCampaigns } = useRequest(
        `/accounts/${selectedAdvertiserId}/campaigns`
    );

    useEffect(() => {
        setCampaigns({
            ...campaigns,
            linkedAdvertiserCampaigns,
        });
    }, [linkedAdvertiserCampaigns, selectedAdvertiserId]);

    const value = {
        campaigns,
        setCampaigns,
        mutateLinkedAdvertiserCampaigns,
    };

    return <CampaignsContext.Provider value={value}>{children}</CampaignsContext.Provider>;
}

CampaignsProvider.propTypes = {
    children: propTypes.node.isRequired,
};
